"use client"

import {
    CheckoutEvents,
    subscribeToPaymentResultEvent,
    unsubscribeFromEvent
} from "@/lib/utils/Events/helpers"
import { useEffect, useState } from "react"

export function usePaymentResultEvent() {
    const [isRoutingToPaymentResult, setIsRoutingToPaymentResult] = useState(false)

    useEffect(() => {
        const handle = subscribeToPaymentResultEvent(setIsRoutingToPaymentResult)

        return () => {
            if (handle) {
                unsubscribeFromEvent(CheckoutEvents.PAYMENT_RESULT_EVENT, handle)
            }
        }
    }, [])

    return isRoutingToPaymentResult
}
